import { get, set } from 'es-toolkit/compat'

const OPAQUE_CROSS_ORIGIN_MESSAGES = ['Uncaught "Script error."', 'Script error.']
const URL_PATHS = ['view.url', 'resource.url', 'error.resource.url']

const isOpaqueCrossOriginError = event =>
  event.type === 'error' && OPAQUE_CROSS_ORIGIN_MESSAGES.includes(event.error?.message)

const scrubEmailFromUrls = event => {
  URL_PATHS.forEach(path => {
    const url = get(event, path)
    if (url) {
      set(event, path, url.replace(/at=[^&]*/, 'at=REDACTED'))
    }
  })
}

export default function beforeSend(event) {
  if (isOpaqueCrossOriginError(event)) {
    return false
  }
  scrubEmailFromUrls(event)
}
